import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Box, Typography, Grid } from '@mui/material';

const StoreFootfallCharts = ({ footfallData, storeSource }) => {

  const data = footfallData[storeSource] || { storeFootfall: 0, employeeFootfall: 0 };
  const ratio = data.employeeFootfall ? (data.storeFootfall / data.employeeFootfall).toFixed(2) : 0;
  
  // Bar chart options for footfall comparison
  const barChartOptions = {
    chart: {
      type: 'bar',
      toolbar: {
        show: false
      },
      sparkline: {
        enabled: true
      }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '70%',
        borderRadius: 4,
        distributed: false
      }
    },
    colors: ['#10B981', '#3B82F6'],
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 6,
      colors: ['transparent']
    },
    xaxis: {
      categories: ['Footfall'],
      labels: {
        show: false
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      }
    },
    yaxis: {
      show: false
    },
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val;
        }
      }
    },
    legend: {
      show: true,
      position: 'top',
      horizontalAlign: 'right',
      fontSize: '12px',
      offsetY: -9
    }
  };

  const barChartSeries = [
    {
      name: 'Customer Footfall',
      data: [data.storeFootfall]
    },
    {
      name: 'Employee Availability',
      data: [data.employeeFootfall]
    }
  ];

  return (
    <Grid container className='h-[100px]' sx={{ mt: 0 }}>
      <Grid item xs={12}>
        <Box sx={{ 
          backgroundColor: 'rgba(16, 185, 129, 0.05)', 
          borderRadius: '8px',
          display: 'flex',
          overflow: 'hidden',
          flex: 1
        }}>
          {/* Left side - Bar Chart */}
          <Box sx={{ 
            flex: '1 1 70%', 
            // p: 2,
            display: 'flex',
            flexDirection: 'column'
          }}>
            {/* <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1rem', mb: 0.5 }}>
              Footfall Comparison
            </Typography> */}
            <Box sx={{ flex: 1, p: 2, mt: 2, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <ReactApexChart 
                options={barChartOptions} 
                series={barChartSeries} 
                type="bar"
                height="88px"
                width="100%"
              />
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box>
                  <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
                    Customer Footfall
                  </Typography>
                  <Typography variant="h3" sx={{ fontWeight: 'bold', color: '#10B981' }}>
                    {data.storeFootfall}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
                    Employee Availability
                  </Typography>
                  <Typography variant="h3" sx={{ fontWeight: 'bold', color: '#3B82F6' }}>
                    {data.employeeFootfall}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
          
          {/* Right side - Ratio Card */}
          <Box sx={{ 
            flex: '1 1 30%',
            backgroundColor: 'rgba(16, 185, 129, 0.1)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            p: 2,
            borderLeft: '1px solid rgba(16, 185, 129, 0.2)'
          }}>
            <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1rem', mb: 1, textAlign: 'center' }}>
              Ratio
            </Typography>
            <Typography variant="h3" sx={{ fontWeight: 'bold', color: '#10B981', mb: 1 }}>
              {ratio}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.75rem', textAlign: 'center' }}>
              Customer to employee ratio indicates store efficiency
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default StoreFootfallCharts;
